import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngHeaderNavComponent } from './kng-header-nav.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { MatRadioModule } from '@angular/material/radio';
import { KngButtonModule } from '../../button';

@NgModule({
	declarations: [KngHeaderNavComponent],
	imports: [
		CommonModule,
		MatSidenavModule,
		MatIconModule,
		MatButtonModule,
		BrowserAnimationsModule,
		RouterModule,
		MatRadioModule,
		KngButtonModule
	],
	exports: [KngHeaderNavComponent],
	providers: []
})
export class KngHeaderNavModule {}
